<script lang="ts">
  import './css/whyChooseUs.scss';
  import { getHref } from '../../helpers/sections-helper';
  import BulletPoint from '../../components/BulletPoint.svelte';
  import type { WhyChooseUs } from '../types';

  export let properties: WhyChooseUs;

  let element: HTMLDivElement;
  let heigh: number;
  let innerWidth: number;

  $: ({ button, callouts, headline, description, items, kicker, image } =
    properties);

  $: if (items.length > 0 && element) {
    if (innerWidth > 1024) {
      element.style.height = `${heigh}px`;
    } else {
      element.style.height = `inherit`;
    }
  }
</script>

<svelte:window bind:innerWidth />

<section class="why-choose-us1">
  <div class="wrapper">
    <div class="quick-top">
      <div class="sub-title">{@html kicker?.value}</div>
      <h2 class="h2">{@html headline?.value}</h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="231"
        height="24"
        viewBox="0 0 231 24"
        fill="none"
      >
        <path
          d="M222.245 2.85393C218.104 3.02094 213.929 3.26654 209.915 4.44053C189.457 -3.84611 166.468 1.62592 145.327 3.65951C98.1709 9.20031 46.9725 22.9098 2.1057 0.623849C2.05969 0.600068 2.0089 0.586997 1.95713 0.585594C1.90536 0.58419 1.85394 0.594501 1.80671 0.615754C1.75948 0.637007 1.71766 0.668641 1.68438 0.70832C1.65109 0.747999 1.6272 0.794692 1.61449 0.844898C1.58401 0.954193 1.59231 1.07067 1.63798 1.17454C1.68364 1.27841 1.76386 1.36327 1.865 1.4147C46.4666 24.9975 98.225 11.6956 145.73 6.98988C165.584 5.42294 186.244 1.42944 205.843 6.26781C200.028 9.46556 201.241 16.2982 208.383 15.6891C214.027 15.9298 216.817 9.32802 211.964 5.83063C217.841 4.32776 223.917 3.75266 229.971 4.12615C230.025 4.13015 230.079 4.12334 230.13 4.10612C230.181 4.0889 230.228 4.06161 230.269 4.02589C230.309 3.99017 230.342 3.94673 230.365 3.89814C230.388 3.84955 230.401 3.7968 230.404 3.74301C230.406 3.6267 230.366 3.51348 230.292 3.42353C230.219 3.33358 230.115 3.27273 230.001 3.2518C227.431 2.90325 224.837 2.77017 222.245 2.85393ZM210.996 11.8381C205.465 15.1095 201.251 11.1651 208.349 7.33372C209.989 8.16877 212.553 10.0255 210.996 11.8184V11.8381Z"
          fill="var(--color-accent)"
        />
        <path
          d="M18.1928 16.7898C34.6531 21.024 51.752 23.3425 68.7085 22.1931C68.744 22.1938 68.778 22.2074 68.8043 22.2313C68.8306 22.2552 68.8474 22.2877 68.8516 22.323C68.8558 22.3583 68.8471 22.3939 68.8271 22.4233C68.8071 22.4527 68.7772 22.4738 68.7428 22.4829C51.6984 25.6797 34.0905 23.8009 18.1044 17.0796C18.0659 17.0679 18.0337 17.0414 18.0148 17.0059C17.996 16.9704 17.9919 16.9289 18.0037 16.8905C18.0154 16.8521 18.0419 16.8199 18.0774 16.801C18.1128 16.7821 18.1543 16.7781 18.1928 16.7898Z"
          fill="var(--color-accent)"
        />
        <path
          d="M72.9525 20.7432C74.5565 20.3376 76.2119 20.172 77.8645 20.252C78.0054 20.2644 78.137 20.327 78.2355 20.4284C78.3341 20.5298 78.3928 20.6633 78.4012 20.8044C78.4095 20.9455 78.3668 21.0849 78.281 21.1972C78.1951 21.3095 78.0717 21.3872 77.9333 21.4161C76.3281 21.7216 74.6993 21.8859 73.0654 21.9073C72.9219 21.9032 72.7849 21.8469 72.68 21.7489C72.5751 21.6509 72.5095 21.518 72.4957 21.3751C72.4818 21.2322 72.5206 21.0892 72.6047 20.9728C72.6888 20.8565 72.8124 20.7748 72.9525 20.7432Z"
          fill="var(--color-accent)"
        />
      </svg>
      <p class="sub-text">
        {@html description?.richText}
      </p>
    </div>

    <div class="quick-desktop">
      <div class="quick-holder" bind:clientHeight={heigh}>
        {#each items as { image, text }}
          <div class="quick-box">
            <img src={image?.value} alt="img-icon" loading="lazy" />
            <p class="text">
              {@html text?.value}
            </p>
          </div>
        {/each}
      </div>
      <div class="image" bind:this={element}>
        <img src={image?.value} alt="img" loading="lazy" />
      </div>
    </div>
    {#if button?.label?.length}
      <div class="bottom-boxes">
        <a
          class="primary-button open-form-js"
          target={button.link_type === 'External' ? '_blank' : ''}
          href={getHref(button.link_type, button.link)}>{@html button.label}</a
        >
        <div class="small-text-box">
          {#each callouts.value as item}
            <div>
              <BulletPoint bulletIcon={callouts.icon} />
              <p class="text-small">{@html item}</p>
            </div>
          {/each}
        </div>
      </div>
    {/if}
  </div>
</section>
